import React, {Component} from 'react';
import withUserActivityTracker from '../../decorators/UserActivityTracker';
import PaymentKioskTimeoutKicker from '../KioskTimeoutKicker/PaymentKioskTimeoutKicker';
import KioskWarningWrapper from "../KioskWarningWrapper/KioskWarningWrapper";

class PaymentKioskComponentsContainer extends Component {
    render() {
        return (
            <div>
                <KioskWarningWrapper/>
                <PaymentKioskTimeoutKicker/>
            </div>
        );
    }
}

export default withUserActivityTracker(PaymentKioskComponentsContainer);


// WEBPACK FOOTER //
// ./src/components/PaymentKioskComponentsContainer/PaymentKioskComponentsContainer.jsx